export enum enumDocumentType {
  UNKNOWN = 0,
  POWER_OF_ATTORNEY = 101,
  ACH_APPROVAL = 102,
  // deprecated, do not use - kept for legacy data compat (truck PoA was unified into POWER_OF_ATTORNEY in #13008)
  POWER_OF_ATTORNEY_TRUCKER = 103,
  COMPANY_ARTICLES_OF_INCORPORATION = 104,
  OFFICERS_AUTHORIZATION_CONFIRMATION = 105,
  ID_DOCUMENT = 106,
  ID_DOCUMENT_1 = 107,
  ID_DOCUMENT_2 = 108,
  COMPANY_ESTABLISHMENT_CERTIFICATE = 109,
  CBP_ASSIGNED_NUMBER_POWER_OF_ATTORNEY = 110,
  DIGITAL_SIGN_PORTFOLIO = 111,
  CONTROLLING_PERSON_STATE_ID = 112,
  // #13356 — IRS SS-4 (EIN assignment letter), required for EIN-registered companies.
  // This is the ONLY place the numeric value appears; everything else uses enumDocumentType.SS4.
  SS4 = 114,
  BILL_OF_LADING = 201,
  INVOICE = 202,
  PERMIT = 203,
  ARRIVAL_NOTICE = 204,
  TRADE_CERTIFICATE = 205,
  PACKING_LIST = 206,
  DELIVERY_ORDER = 207,
  FILE_PREVIEW = 208,
  CBP_FORM_7501 = 301,
  CARGO_RELEASE_FORM_3461 = 302,
  CARGO_RELEASE_FILE = 303,
  PRELIMINARY_STATEMENT = 304,
  FINAL_STATEMENT = 305,
  CARGO_MANIFEST = 306,
  // resolved at runtime via reverse-lookup enumDocumentType[doc.type] (PGA forms, #13088)
  EPA_FORM_3520_1 = 307,
  FDA_FORM_2877 = 309,
  NHTSA_FORM_HS7 = 310,
  ISF_FORM = 401,
  ISF_STATUS_SHEET = 402,
  /* LCL */
  FREIGHT_USER_INVOICE = 501,
  FREIGHT_USER_PACKING_LIST = 502,
  FREIGHT_USER_EXPORT_LICENSE = 503,
  FREIGHT_USER_ISF_FORM_10_PLUS_2 = 504,
  FREIGHT_PACKING_LIST_SUPPORT = 551,
  FREIGHT_INVOICE_SUPPORT = 552,
  FREIGHT_EXPORT_LICENSE_SUPPORT = 553,
  FREIGHT_HOUSE_BILL_OF_LANDING_DRAFT = 554,
  FREIGHT_HOUSE_BILL_OF_LANDING = 555,
  FREIGHT_ISF_FORM = 556,
  FREIGHT_RELEASE = 557,
  FREIGHT_OTHER = 558,
  FREIGHT_FREIGHT_DAMAGED_GOODS_PICS = 559,
  FREIGHT_FREIGHT_REPACKED_GOODS_PICS = 560,
  FREIGHT_ARRIVAL_NOTICE = 561,
  FREIGHT_POD = 562,
  TELEX_RELEASE = 601,
  MASTER_BILL_OF_LADING = 602,
  DRAFT_MASTER_BILL_OF_LADING = 603,
  SHIPPING_ORDER = 604,
  DEBIT_NOTE = 605,
  LOADING_PLAN = 606,
  MANIFEST = 607,
  PRICE_LIST = 608,
  /* Marine Insurance */
  MARINE_INSURANCE_CERTIFICATE = 709,
  SAP_INVOICE = 801,
}
